/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// triggers when gallery is ready
document.addEventListener('galleryReady:covetPics', function(e) {
  // prepare CSS styles to inject
  const stylesPopup = document.createElement( 'style' )
  stylesPopup.innerHTML = `
.links .product {
    width: 75%!important;
}
.links .product-title {
    font-size: 19px!important;
    line-height: 19px!important;
  white-space: break-spaces!important;
}
.links .product-link {
height: auto!important;
}
  `
  // get Covet gallery elements where you want to inject CSS (for eg. covet-pics-widget, covet-pics-popup, covet-pics-upload)
  const popup = document.querySelector("covet-pics-popup");
  
  // now inject CSS code into shadow DOM
  popup.shadowRoot.appendChild(stylesPopup);
});

 document.addEventListener('variant:changed', function(event) {
   var variant = event.detail.variant; // Gives you access to the whole variant details
   if (variant) {
     var id = variant.id;
     var sku = variant.sku;

     try {
       getVariantId(sku);
     } catch (error) { }
    
     shippingInfo(id);
}
   function shippingInfo(variantId) {
     // console.log(variantId);
   }
 });